import { Box, Zoom } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { UploadDetail } from '../../../../../services/entities/impl/blfApi/schemas/uploadSummary';
import { UploadProgress } from '../UploadProgress';
import { UploadStatusLabel } from './UploadStatusLabel';

type UploadStatusProps = {
  status: UploadDetail['status'];
  progress: string | number;
};

export const UploadStatus = ({ status, progress }: UploadStatusProps) => {
  if (status === 'Uploading') {
    return <UploadProgress progress={progress} />;
  }

  return <UploadStatusLabel status={status} />;
};

type AnimatedUploadStatusProps = UploadStatusProps &
  Pick<TransitionProps, 'in'>;

export const AnimatedUploadStatus = ({
  in: _in,
  ...uploadStatusProps
}: AnimatedUploadStatusProps) => {
  return (
    <Zoom in={_in}>
      {/* Having to wrap the component I want animated in a Box is not standard practice.
      This is because UploadStatus has multiple return statements without a constant base wrapper.
      I chose to add the wrapper here in this helper component since the wrapper isn't needed for
      the UploadStatus logic, but for the Transition/Animation functionality. That is one of
      the reasons I created AnimatedUploadStatus */}
      <Box>
        <UploadStatus {...uploadStatusProps} />
      </Box>
    </Zoom>
  );
};
